<script>
export default {
  name: 'BasePageSubtitle',
}
</script>

<template>
  <p class="page-subtitle">
    <slot />
  </p>
</template>

<style lang="scss" scoped>
.page-subtitle {
  margin: 0;
  margin-top: 4px;
  font-size: 12px;
  opacity: 0.7;
}
</style>
